import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { useGetSummaryList } from './useGetSummaryList';
import { EncounterSummary } from 'src/models';

type UseUpdateSummaryPayload = {
  summaryId: string;
  payload: Partial<Pick<EncounterSummary, 'summary_json' | 'ehr_id'>>;
};

export const useUpdateSummary = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateSummary'],
    mutationFn: ({ summaryId, payload }: UseUpdateSummaryPayload) => {
      queryClient.setQueriesData<ReturnType<typeof useGetSummaryList>['data']>(
        { queryKey: ['summaryList'] },
        (old) => {
          if (!old) return old;

          return {
            ...old,
            summaries: old.summaries?.map((summary) =>
              summary.summary_id === summaryId
                ? { ...summary, ...payload }
                : summary
            ),
          };
        }
      );
      return ambientApi
        .put(`/summaries/${summaryId}`, payload)
        .then((res) => res.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['summaryList'] });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ['summaryList'] });
    },
  });
};
